import React, { useState } from "react";
import { apiFetch } from "../utils/wkCommon";
import ConfirmDangerDialog from "./ConfirmDangerDialog";
import { isZh } from "../utils/language";
import FileFormDialog from "./FileFormDialog";

export default function DocumentList({
  user,
  documents,
  folders,
  canEdit,
  selectedDoc,
  onSelectDoc,
  onPreview,
  onOpenFolder,
  onGoUp,
  activeFolder,
  loading,
  onDelete
})
{
  const [toDelete, setToDelete] = useState(null);
  const [editingFile, setEditingFile] = useState(null);
  const isRoot = !activeFolder;
  const isEmpty = folders.length === 0 && documents.length === 0;

  function getFileIcon(filename = "") {
    const ext = filename.split(".").pop()?.toLowerCase();

    const map = {
      pdf: "/icons/pdf.png",
      doc: "/icons/doc.png",
      docx: "/icons/doc.png",
      ppt: "/icons/file.png",
      pptx: "/icons/file.png",
      xls: "/icons/xls.png",
      xlsx: "/icons/xls.png",
      txt: "/icons/txt-file.png",
      csv: "/icons/csv.png",
      png: "/icons/picture.png",
      jpg: "/icons/picture.png",
      jpeg: "/icons/picture.png",
      gif: "/icons/picture.png",
      webp: "/icons/picture.png",
      mp4: "/icons/video.png",
      mov: "/icons/video.png",
    };

    return map[ext] || "/icons/file.png";
  }

  return (
    <>
    <div>
    {activeFolder && (
      <div
        className="document-row folder-up-row"
        onClick={onGoUp}
      >
        <img
          src="/icons/folder_up.png"
          alt=""
          className="folder-up-icon"
        />
        <div className="folder-up-text">
          {isZh() ? "返回上層" : "Folder Up"}
        </div>
      </div>
    )}

    {/* Empty State hanya jika root kosong */}
    {isRoot && isEmpty && (
      <div className="empty-state">
        {isZh() ? "目前沒有資料" : "Tidak ada dokumen dalam folder ini."}
      </div>
    )}

    { loading && (
      <div style={{ padding: "2rem", textAlign:"center", color:"#666", fontSize:"0.9rem" }}>
        {isZh() ? "載入中..." : "Memuat dokumen..."}
      </div>
    )}

    { !loading && (
      <div className="file-grid">

          {folders.map(f => (
            <div
              key={f.documentId}
              className="file-item folder-item"
              onClick={() => onOpenFolder(f)}
              style={{ cursor: "pointer", fontWeight: 600 }}
            >
              <div className="file-icon">
                <img
                  src="/icons/folder.png"
                  alt=""
                  className="file-icon-img"
                />
              </div>
              <div className="file-name">
                {isZh() ? f.name_zh : f.name}
              </div>
            </div>
          ))}

          {documents?.filter(Boolean).map(d => {
            const filename = d.title_id || "";
            const ext = d.object_key?.split(".").pop()?.toUpperCase() || "";
            const sizeKB = d.file_size
              ? (d.file_size / 1024).toFixed(1)
              : null;

            return (
              <div
                key={d.documentId}
                className={`file-item ${
                  selectedDoc?.documentId === d.documentId ? "active" : ""
                }`}
                onClick={() => onSelectDoc(d)}
              >
                <div className="file-icon">
                  <img
                    src={getFileIcon(d.object_key)}
                    alt=""
                    className="file-icon-img"
                  />
                </div>

                <div className="file-info">
                  <div className="file-title">
                    {isZh() ? d.title_zh : d.title_id}
                  </div>

                  <div className="file-meta">
                    {ext}
                    {sizeKB && ` • ${sizeKB} KB`}
                  </div>
                </div>
              </div>
            )})}
      </div>
    )}

    {toDelete && (
      <ConfirmDangerDialog
        title="Hapus Dokumen"
        message={`Hapus "${toDelete.title_id}"`}
        onConfirm={() => onDelete && onDelete(toDelete)}
        onCancel={() => setToDelete(null)}
      />
    )}

    {editingFile && (
      <FileFormDialog
        user={user}
        file={editingFile}
        onClose={() => setEditingFile(null)}
        onSaved={() => {
          setEditingFile(null);
          window.location.reload(); // atau reload docs saja
        }}
      />
    )}
    
    {/* Jika subfolder kosong tapi bukan root → tetap tampil FolderUp */}
    {!isRoot && !loading && isEmpty && (
      <div className="empty-state">
        {isZh() ? "此資料夾為空" : "Tidak ada dokumen dalam folder ini."}
      </div>
    )}
    </div>
    </>
  );
}
